import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Vishrantwaditomumbaicab() {



  const cardData =
  {
    keyword: ' Vishrantwadi to Mumbai Cab',
    heading: 'Sai Trupti Cabs: Vishrantwadi to Mumbai Cab',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Vishrantwadi (Pune) to Mumbai cab services, designed to make your inter-city journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Vishrantwadi, courteous service, and safe, smooth driving all the way to Mumbai. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Vishrantwadi to Mumbai convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Mumbai with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India is the crown jewel of Mumbai’s waterfront, standing proudly on the Apollo Bunder overlooking the Arabian Sea. Built in 1924 to commemorate the visit of King George V and Queen Mary, this basalt arch is a symbol of Mumbai’s grandeur and cosmopolitan charm. It’s the first landmark to welcome travelers arriving by sea and the starting point for ferries to Elephanta Caves. The structure glows beautifully at sunrise and sunset, attracting tourists, photographers, and history lovers alike. With the iconic Taj Mahal Palace Hotel in the backdrop, it remains Mumbai’s most photographed and celebrated monument — a true emblem of the city’s timeless spirit."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, lovingly called the Queen’s Necklace, is Mumbai’s most scenic and romantic seaside boulevard. Stretching over 3.6 kilometers from Nariman Point to Girgaum Chowpatty, its gracefully curving shape resembles a string of shining pearls when lit up at night. The walkway is perfect for morning jogs, evening strolls, or simply sitting by the sea as waves kiss the promenade. The cool ocean breeze and stunning sunsets make it a favorite among locals and tourists alike. With its iconic skyline views and art deco buildings, Marine Drive reflects Mumbai’s soul — energetic, elegant, and forever young."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "Chhatrapati Shivaji Maharaj Terminus, a UNESCO World Heritage Site, is one of India’s greatest architectural masterpieces. Completed in 1887, it combines Victorian Gothic design with traditional Indian craftsmanship. The domes, stained-glass windows, and intricate stone carvings showcase unmatched artistry from the British era. Today, it remains one of the busiest railway stations in Asia, where the pulse of Mumbai can be felt every minute. As trains arrive and depart in rhythm, the station becomes a living monument of heritage, progress, and the city’s unstoppable energy. CSMT isn’t just a terminus — it’s the beating heart of Mumbai."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular seaside escape, stretching endlessly along the Arabian Sea. Known for its golden sands and lively atmosphere, it’s a favorite spot for locals to unwind and for tourists to experience the city’s coastal charm. The beach comes alive in the evenings with food vendors serving Mumbai’s famous pav bhaji, bhel puri, and kulfi. Children play, couples stroll, and photographers capture sunsets that paint the sky in hues of orange and pink. Juhu is also home to many Bollywood celebrities, making it a hotspot for fans and visitors. It’s where Mumbai’s joy, food, and freedom meet the waves."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah stands gracefully on a small islet off Worli, appearing to float on the sea during high tide. Built in the 15th century, this stunning white marble mosque houses the tomb of Sufi saint Pir Haji Ali Shah Bukhari. The narrow causeway connecting it to the mainland adds to its mystique and charm. Pilgrims and visitors of all faiths come here to seek blessings, peace, and inspiration. The sound of waves, the sight of fluttering prayer flags, and the serene prayers inside the shrine create a divine atmosphere. Haji Ali beautifully represents Mumbai’s spirit of inclusivity, faith, and eternal devotion."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located on Elephanta Island, about 10 kilometers from Mumbai’s coast, the Elephanta Caves are a UNESCO World Heritage treasure dating back to the 5th century. The caves feature magnificent rock-cut sculptures dedicated to Lord Shiva, with the towering Trimurti — a three-headed depiction of the deity — as the centerpiece. The island, accessible by ferry from the Gateway of India, offers stunning views of Mumbai’s skyline along the journey. As visitors step inside the ancient caves, they’re transported into a world of myth, art, and spirituality. It’s a must-visit for anyone seeking to explore India’s ancient cultural depth within reach of a modern metropolis."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "The Shree Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most sacred and visited temples, dedicated to Lord Ganesha — the remover of obstacles. Built in 1801, the temple’s golden dome and intricately carved idol attract millions of devotees every year. People from all walks of life, including film stars and politicians, visit to seek blessings before major life events. The temple’s serene atmosphere is filled with chants and the fragrance of flowers, radiating divine energy. It stands as a symbol of faith, hope, and prosperity in the heart of India’s busiest city. Siddhivinayak truly embodies Mumbai’s spiritual rhythm."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra–Worli Sea Link is a modern engineering marvel that connects South Mumbai to its western suburbs. Stretching over 5.6 kilometers, its cable-stayed structure glistens magnificently, especially when illuminated at night. The bridge not only reduces travel time but also offers breathtaking panoramic views of the Arabian Sea and the city skyline. Driving across it at dawn or dusk feels like gliding through a futuristic masterpiece. It’s more than infrastructure — it’s a proud symbol of Mumbai’s innovation, ambition, and progress. For every traveler, the Sea Link represents the city’s unstoppable drive toward modernity."
  },
  {
    "title": "Colaba Causeway Market",
    "description": "Colaba Causeway is the ultimate shopping and cultural hub of South Mumbai. From fashionable clothes and antique jewelry to souvenirs and leather goods, it’s a paradise for bargain hunters and explorers. The lively streets echo with calls of vendors and the chatter of visitors, creating an irresistible urban charm. Nearby, iconic cafés like Leopold and Café Mondegar offer classic Mumbai vibes with music and art. The area’s colonial-era architecture adds elegance to its bustling energy. Whether you’re shopping, dining, or people-watching, Colaba perfectly captures Mumbai’s mix of heritage, creativity, and cosmopolitan spirit."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park, spread over 100 square kilometers in the northern part of Mumbai, is one of the largest urban forests in the world. It’s home to lush greenery, serene lakes, leopards, deer, and over 250 species of birds. Inside the park lie the ancient Kanheri Caves, carved by Buddhist monks more than 2,000 years ago. Visitors can trek, cycle, or take a toy train ride through the scenic landscapes. The park offers a refreshing contrast to the city’s urban rush — a peaceful haven where nature, history, and spirituality coexist beautifully. It’s Mumbai’s green heart, beating quietly amid the city’s chaos."
  }
],



"services": [
    {
      "name": "Vishrantwadi to Mumbai Cab",
      "description": "Reliable cab service from Vishrantwadi to Mumbai offering AC and non-AC vehicles, professional drivers, luggage assistance, flexible pickup and drop points, real-time tracking, and transparent fares. Ideal for solo travelers, families, and corporate commuters."
    },
    {
      "name": "Vishrantwadi to Mumbai Taxi",
      "description": "Convenient taxi service from Vishrantwadi to Mumbai with AC/non-AC options, experienced drivers, luggage support, flexible schedules, and real-time tracking. Perfect for business trips, weekend travel, and daily commuting."
    },
    {
      "name": "Vishrantwadi to Mumbai Car Hire",
      "description": "Car hire service from Vishrantwadi to Mumbai offering multiple vehicle options including Sedans, SUVs, and luxury cars. Features professional drivers, AC/non-AC options, luggage assistance, flexible pickup/drop points, and transparent fares for comfortable travel."
    },
    {
      "name": "Vishrantwadi to Mumbai Innova Cab",
      "description": "Travel in a spacious Innova cab from Vishrantwadi to Mumbai with AC service, comfortable seating for families or groups, professional drivers, luggage assistance, flexible pickup/drop points, and transparent fares. Perfect for group travel or corporate trips."
    },
    {
      "name": "Vishrantwadi to Mumbai Ertiga Cab",
      "description": "Ertiga cab service from Vishrantwadi to Mumbai providing seating for small to medium groups, AC/non-AC options, professional drivers, luggage support, flexible schedules, and transparent fares. Ideal for family trips and corporate travel."
    },
    {
      "name": "Vishrantwadi to Mumbai Sedan Cab",
      "description": "Sedan cab service from Vishrantwadi to Mumbai offering smooth and comfortable rides with professional drivers, AC/non-AC options, luggage support, flexible pickup/drop points, and transparent fares. Suitable for solo travelers, couples, and small families."
    },
    {
      "name": "Vishrantwadi to Mumbai One Way Cab",
      "description": "One-way cab service from Vishrantwadi to Mumbai providing direct, point-to-point travel with AC/non-AC vehicles, professional drivers, luggage support, flexible schedules, real-time tracking, and transparent fares. Perfect for quick and hassle-free transport."
    },
    {
      "name": "Vishrantwadi to Mumbai Drop Cab",
      "description": "Drop cab service from Vishrantwadi to Mumbai ensuring safe and timely point-to-point travel with AC and non-AC vehicles, professional drivers, luggage support, flexible pickup/drop points, real-time tracking, and transparent fares. Ideal for corporate commuters and families."
    },
    {
      "name": "Vishrantwadi to Mumbai Luxury Cab",
      "description": "Premium luxury cab service from Vishrantwadi to Mumbai with top-class vehicles, professional chauffeurs, luggage support, flexible pickup/drop points, real-time tracking, and transparent fares. Perfect for executives, VIP travelers, weddings, and corporate events."
    },
    {
      "name": "Vishrantwadi to Mumbai Outstation Cab",
      "description": "Outstation cab service from Vishrantwadi to Mumbai offering long-distance travel comfort with AC/non-AC vehicles, professional drivers, luggage assistance, flexible schedules, online booking, real-time tracking, and transparent fares. Ideal for weekend trips and family outings."
    },
    {
      "name": "Affordable Vishrantwadi to Mumbai Cab",
      "description": "Budget-friendly cab service from Vishrantwadi to Mumbai with AC/non-AC options, professional drivers, luggage assistance, flexible pickup/drop points, real-time tracking, and transparent fares. Perfect for students, families, and corporate clients seeking economical transport."
    },
    {
      "name": "Vishrantwadi to Mumbai AC Cab",
      "description": "AC cab service from Vishrantwadi to Mumbai offering cool, comfortable, and safe travel for solo travelers, families, and corporate clients. Includes professional drivers, luggage assistance, flexible schedules, real-time tracking, multiple vehicle options, and transparent fares."
    },
    {
      "name": "Vishrantwadi to Mumbai Online Booking",
      "description": "Book your Vishrantwadi to Mumbai cab online instantly with multiple vehicle options including Innova, Sedan, and luxury cars. Features secure payments, real-time tracking, AC/non-AC options, professional drivers, luggage assistance, flexible pickup/drop locations, and transparent fares."
    },
    {
      "name": "Vishrantwadi to Mumbai Corporate Cab",
      "description": "Corporate cab service from Vishrantwadi to Mumbai offering AC/non-AC vehicles, professional drivers, flexible schedules, luggage assistance, real-time tracking, and transparent fares. Ideal for business executives, corporate employees, and frequent travelers seeking professional transport."
    },
    {
      "name": "Vishrantwadi to Mumbai Cab Near Me",
      "description": "Find Vishrantwadi to Mumbai cabs near your location for quick and convenient booking. Includes AC/non-AC vehicles, professional drivers, luggage support, flexible pickup/drop points, real-time tracking, well-maintained vehicles, and transparent fares ensuring reliable and comfortable travel."
    }
  ],
  "tableData": [
    ["Vishrantwadi to Mumbai Cab", "Vishrantwadi to Mumbai Taxi"],
    ["Vishrantwadi to Mumbai Car Hire", "Vishrantwadi to Mumbai Innova Cab"],
    ["Vishrantwadi to Mumbai Ertiga Cab", "Vishrantwadi to Mumbai Sedan Cab"],
    ["Vishrantwadi to Mumbai One Way Cab", "Vishrantwadi to Mumbai Drop Cab"],
    ["Vishrantwadi to Mumbai Luxury Cab", "Vishrantwadi to Mumbai Outstation Cab"],
    ["Affordable Vishrantwadi to Mumbai Cab", "Vishrantwadi to Mumbai AC Cab"],
    ["Vishrantwadi to Mumbai Online Booking", "Vishrantwadi to Mumbai Corporate Cab"],
    ["Vishrantwadi to Mumbai Cab Near Me", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Vishrantwadi to Mumbai Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs  provides reliable and comfortable cab services from Vishrantwadi (Pune) to Mumbai — ideal for business travel, airport transfers, and personal trips."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Our one-way fares from Vishrantwadi to Mumbai start from approximately ₹2,100–₹2,900 for sedans, with SUV and luxury car options available at affordable rates."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, tempo travellers, or premium cars to suit your group size, luggage, and comfort preferences for the Vishrantwadi → Mumbai route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers ensure a safe, smooth, and punctual journey on the Vishrantwadi to Mumbai route."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide convenient pickups anywhere in Vishrantwadi and drop-offs across Mumbai — including popular areas, airports, railway stations, and city locations."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized, and maintained to provide a comfortable and reliable travel experience."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, route planning, and customer queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Vishrantwadi to Mumbai cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]













  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Vishrantwadi to Mumbai cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable cab services from Vishrantwadi to Mumbai for one-way, round-trip, and group travel.',
  },
  {
    question: 'How can I book a Vishrantwadi to Mumbai cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Vishrantwadi to Mumbai cab through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available from Vishrantwadi to Mumbai?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and luxury cabs to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for Vishrantwadi to Mumbai trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance travel, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I hire a cab from Vishrantwadi to Mumbai for corporate or personal travel?',
    answer: 'Certainly. Our cab services cater to corporate clients, airport transfers, family trips, and leisure travel between Vishrantwadi and Mumbai.',
  },
  {
    question: 'Is the Vishrantwadi to Mumbai cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services for Vishrantwadi to Mumbai trips for maximum convenience and travel flexibility.',
  },
  {
    question: 'What are the Vishrantwadi to Mumbai cab fares?',
    answer: 'Our cab fares start from approximately ₹1,800 for sedans, ₹2,500–₹3,500 for SUVs and premium vehicles, depending on distance, vehicle type, and travel requirements.',
  },
  {
    question: 'What payment options are accepted for Vishrantwadi to Mumbai cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Vishrantwadi to Mumbai cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures to ensure a secure journey.',
  },
  {
    question: 'Is customer support available during the Vishrantwadi to Mumbai cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Vishrantwadi to Mumbai cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sanjay Kulkarni',
    feedback: 'I booked a Vishrantwadi to Mumbai cab with Sai Trupti Cabs. The ride was comfortable, and the driver was professional and punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ananya Patil',
    feedback: 'Sai Trupti Cabs provided excellent service for our Vishrantwadi to Mumbai trip. Smooth journey and very courteous driver.',
    rating: 5,
  },
];
















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Vishrantwadi to Mumbai Cab",
  "image": "https://saitrupticabs.com/assets/images/pune-to-shirdi-cab.jpg",
  "description": "Book Vishrantwadi to Mumbai Cab with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15864"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/vishrantwadi-to-mumbai-cab"
  }
};







  return (
    <div>
      <Helmet>
  <title>Vishrantwadi to Mumbai Cab | Safe & Comfortable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Vishrantwadi to Mumbai Cab with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking." 
  />
  <meta 
    name="keywords" 
    content="Vishrantwadi to Mumbai Cab, Vishrantwadi to Mumbai Taxi, Vishrantwadi to Mumbai Car Hire, Vishrantwadi to Mumbai Innova Cab, Vishrantwadi to Mumbai Ertiga Cab, Vishrantwadi to Mumbai Sedan Cab, Vishrantwadi to Mumbai One Way Cab, Vishrantwadi to Mumbai Drop Cab, Vishrantwadi to Mumbai Luxury Cab, Vishrantwadi to Mumbai Outstation Cab, Affordable Vishrantwadi to Mumbai Cab, Vishrantwadi to Mumbai AC Cab, Vishrantwadi to Mumbai Online Booking, Vishrantwadi to Mumbai Corporate Cab, Vishrantwadi to Mumbai Cab Near Me" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/27.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Vishrantwaditomumbaicab;